<template>
  <div ref="container-contract-detail-job-request">
    <b-row>
      <b-col cols="12">
        <contract
          v-for="item in contracts"
          :key="item.id"
          :generate-key="+item.id"
          :contract-input="item"
          :accordion="accordion"
          :hide-send-package-btn="false"
          :show-pay-code="false"
          :fill-class-container="'container-layout'"
          :hide-btn-delete="true"
          :hide-btn-copy="true"
          :hide-btn-save-template="true"
          :from-job-request="true"
          :use-memo-deal="true"
          @contract:show-body="handleContractShowBody"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="4" offset-md="8" lg="4" offset-lg="8" xl="4" offset-xl="8">
        <div class="d-flex">
          <b-button
            block
            variant="primary"
            :disabled="disableBtnUserInProject || loadingAddUserInProject || showInfoUserAlreadyAddInProject"
            @click="handleClickAddUserInProject"
          >
            <b-spinner v-if="loadingAddUserInProject" small />
            {{ FormMSG(487, 'Add user in project') }}
          </b-button>
          <button
            v-if="disableBtnUserInProject"
            v-b-tooltip.hover
            class="btn-transparent text-color-tree-sap ml-2"
            :title="FormMSG(497, 'You must create or select a project and linked with the job request')"
          >
            <component :is="getLucideIcon('AlertTriangle')" :size="20" />
          </button>
          <button
            v-if="showInfoUserAlreadyAddInProject"
            v-b-tooltip.hover
            class="btn-transparent text-color-blue-streak ml-2"
            :title="FormMSG(1497, 'The user has already added in project')"
          >
            <component :is="getLucideIcon('Info')" :size="20" />
          </button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import contract from '@/views/users/contract';
import { contracts } from '@/cruds/contract.crud';
import { mapGetters, mapActions } from 'vuex';
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import { addJobRequestOnProject } from '@/cruds/job-request.crud';
import _ from 'lodash';

export default {
  name: 'ContractDetail',
  components: {
    contract
  },
  mixins: [languageMessages, globalMixin],
  data() {
    return {
      contracts: [],
      accordion: {},
      loadingAddUserInProject: false,
      jobRequest: {
        targetProjectId: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      currentJobRequest: 'job-request/currentJobRequest'
    }),
    userIsCreated() {
      return !!this.currentJobRequest.userCreated;
    },
    showInfoUserAlreadyAddInProject() {
      return (!JSON.stringify(this.currentJobRequest) === '{}' && !_.isNil(this.currentJobRequest)) || !!this.currentJobRequest.userCreated === true;
    },
    disableBtnUserInProject() {
      return JSON.stringify(this.currentJobRequest) === '{}' || _.isNil(this.currentJobRequest) || this.currentJobRequest.targetProjectId === 0;
    }
  },
  watch: {
    currentJobRequest: {
      async handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== '{}' && !_.isNil(newVal)) {
          this.jobRequest = newVal;
          if (!_.isNil(oldVal) && newVal.targetProjectId !== oldVal.targetProjectId) await this.getContracts();
        }
      },
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.$nextTick(async () => {
      await this.getContracts();
    });
  },
  methods: {
    ...mapActions({
      setCurrentJobRequest: 'job-request/setCurrentJobRequest'
    }),
    async handleClickAddUserInProject() {
      const action = async () => {
        this.loadingAddUserInProject = true;
        const result = await addJobRequestOnProject(+this.currentJobRequest.id);

        this.setCurrentJobRequest(result);

        this.loadingAddUserInProject = false;
        this.createToastForMobile(this.FormMSG(451, 'Success'), this.FormMSG(452, 'User added successfully in project successfully!'));
      };

      this.confirmModal(action, this.FormMSG(460, 'Are you sure to add this user in project ?'));
    },
    handleContractShowBody(payload) {
      this.accordion = payload;
    },
    async getContracts() {
      const actionForLoader = async () => {
        const contractList = await contracts(this.currentJobRequest.userId, this.currentJobRequest.id);
        if (contractList && contractList.length > 0) {
          this.contracts = contractList.map((contract) => {
            return { ...contract, companyCostFactor: contract.companyCostFactor > 0 ? contract.companyCostFactor : 1 };
          });
        }
      };

      await this.showLoader(actionForLoader, 'container-contract-detail-job-request');
    }
  }
};
</script>

<style scoped></style>
